import React, { FC } from 'react';
import { DependentTasks } from 'components/molecules/tasks/details/dependent-tasks';
import { ProjectTemplateTask, useGetAllTasks } from 'data/templates/projects';

export const DependentTaskSection: FC<{
  task: ProjectTemplateTask;
  onCreateDependency(dependentTask: ProjectTemplateTask): void;
  onUpdateTask(task: ProjectTemplateTask): void;
}> = ({ task, onCreateDependency, onUpdateTask }) => {
  const allTasks = useGetAllTasks();

  const fetchDependentTasks = () =>
    Promise.resolve<ProjectTemplateTask[]>(
      Object.values(allTasks).filter((_task) => !_task.isNew),
    );

  const removeDependency = (dependentTask: ProjectTemplateTask) => {
    onUpdateTask({
      ...task,
      dependentTasks: (task.dependentTasks || []).filter(
        (t) => t.taskId !== dependentTask.taskId,
      ),
    });
  };

  return (
    <DependentTasks.List
      data={task.dependentTasks}
      taskId={task.taskId}
      onFetchTasks={fetchDependentTasks}
      onCreateDependency={onCreateDependency}
      onRemoveDependency={removeDependency}
    />
  );
};
